import actions from '@/core/store/documentos/actions'
import editorTexto from '@/core/store/documentos/editor-texto'
import anexos from '@/core/store/documentos/anexos'
import pncp from '@/core/store/documentos/pncp'
import processoDigital from '@/core/store/documentos/processo-digital'
import signatarios from '@/core/store/documentos/signatarios'

export default {
	actions,
	modules: {
		editorTexto,
		anexos,
		processoDigital,
		signatarios,
		pncp,
	},
}
